import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { Link } from 'react-router-dom';
import IntegrationDetailsContent from '../IntegrationDetails/Includes/IntegrationDetailsContent';
import { getPath, removeHyphen } from 'utlis/helpers/Common/Helper';
import { INTEGRATIONTABLE, INTEGRATIONTOP } from '../Includes/ConstArray';


function IntegrationDetails() {
    const [key, setKey] = useState("")

    useEffect(() => {
        setKey(removeHyphen(getPath(window.location)))
    }, []);

    const integrations = INTEGRATIONTABLE.find(e => e.title === key) || {}
    const integrations_ = INTEGRATIONTOP.find(e => e.title === key) || {}
    return (
        <section id="app-integration-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-integrations">
                    <Link
                        className="st-btn st-btn-link text-primary border-light bg-transparent no-min-width st-btn-sm p-0 min-height-auto"
                        to="/settings/integration"
                    >
                        <FeatherIcon
                            icon="arrow-left"
                            size="14"
                            className="icon me-2" />
                        <span>Back</span>
                    </Link>
                    <div className="app-header-integrations mb-3">
                        <p className="app-heading text-capitalize">{integrations.title || integrations_.title}</p>
                        <p className="app-desc">{integrations.sub_title || integrations_.sub_title}</p>
                    </div>
                    <Col xs={12} md={12} lg={12} className="px-0">
                        <IntegrationDetailsContent />
                    </Col>
                </div>
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(IntegrationDetails)